import { formatPaymentStatusDisplay } from '../utils/paymentUtils';

const map = {
  'Pending (Cash on Delivery)': 'badge-pending',
  'Pending (COD)': 'badge-pending',
  'Pending Verification': 'badge-unread',
  Verified: 'badge-confirmed',
  Rejected: 'badge-cancelled',
};

export default function PaymentStatusBadge({ status }) {
  const label = formatPaymentStatusDisplay(status);
  return (
    <span className={`badge ${map[status] || map[label] || 'badge-pending'}`}>
      {label}
    </span>
  );
}
